__turbopack_context__.v({
  "desktop": "ResponsiveAsset-module-scss-module__K1rBua__desktop",
  "hasDesktop": "ResponsiveAsset-module-scss-module__K1rBua__hasDesktop",
  "hasMobile": "ResponsiveAsset-module-scss-module__K1rBua__hasMobile",
  "mobile": "ResponsiveAsset-module-scss-module__K1rBua__mobile",
  "stack-module-0": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-0",
  "stack-module-1": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-1",
  "stack-module-10": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-10",
  "stack-module-11": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-11",
  "stack-module-12": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-12",
  "stack-module-13": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-13",
  "stack-module-14": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-14",
  "stack-module-15": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-15",
  "stack-module-16": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-16",
  "stack-module-17": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-17",
  "stack-module-18": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-18",
  "stack-module-19": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-19",
  "stack-module-2": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-2",
  "stack-module-20": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-20",
  "stack-module-3": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-3",
  "stack-module-4": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-4",
  "stack-module-5": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-5",
  "stack-module-6": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-6",
  "stack-module-7": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-7",
  "stack-module-8": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-8",
  "stack-module-9": "ResponsiveAsset-module-scss-module__K1rBua__stack-module-9",
  "z-base": "ResponsiveAsset-module-scss-module__K1rBua__z-base",
  "z-content": "ResponsiveAsset-module-scss-module__K1rBua__z-content",
  "z-footer": "ResponsiveAsset-module-scss-module__K1rBua__z-footer",
  "z-header": "ResponsiveAsset-module-scss-module__K1rBua__z-header",
  "z-hero": "ResponsiveAsset-module-scss-module__K1rBua__z-hero",
  "z-logo": "ResponsiveAsset-module-scss-module__K1rBua__z-logo",
  "z-logo-effect": "ResponsiveAsset-module-scss-module__K1rBua__z-logo-effect",
  "z-navigation": "ResponsiveAsset-module-scss-module__K1rBua__z-navigation",
  "z-sub": "ResponsiveAsset-module-scss-module__K1rBua__z-sub",
});
